module.exports = __webpack_public_path__ + "img/1-w.61ae5025.jpg";